<template>
  <div class="mob-inject" style="padding-top: 0">
    <div class="selection">
      <div class="selection-top">
        <div class="selection-arrow"></div>
        <span>{{ $t("edit.editActionTitles.specialEffectsSetting") }}</span>
        <div class="click-btn" @click="onClickFinish">
          {{ $t("actionTitles.finish") }}
        </div>
      </div>
      <div class="selection-bottom">
        <div class="select-type" v-if="!isSetshine">
          <a-radio-group v-model="special_is_global" @change="onChange">
            <a-radio :value="1">{{$t("edit.editActionTitles.applyglobal")}}</a-radio>
            <a-radio :value="0">{{$t("edit.editActionTitles.scene")}}</a-radio>
          </a-radio-group>
        </div>

        <div class="select-effects">
          <div class="effect-lists">
            <a-radio
              style="padding: 10px 10px 10px 0"
              :value="item.value"
              v-for="(item, index) in specialEffects"
              :checked="item.value === currentSpecialType"
              :key="index + item.value"
              @click.native="onSpecialChange(item.value)"
              >{{ item.title }}</a-radio
            >
          </div>
          <!--<div class="effect-lists">
            <a-radio
              style="padding: 10px 10px 10px 0"
              :value="item.value"
              v-for="(item, index) in specialEffects.slice(3, 6)"
              :checked="item.value === currentSpecialType"
              :key="index + item.value"
              @click.native="onSpecialChange(item.value)"
              >{{ item.title }}</a-radio
            >
          </div>
          <div class="effect-lists">
            <a-radio
              style="padding: 10px 10px 10px 0"
              :value="item.value"
              v-for="(item, index) in specialEffects.slice(6, 10)"
              :checked="item.value === currentSpecialType"
              :key="index + item.value"
              @click.native="onSpecialChange(item.value)"
              >{{ item.title }}</a-radio
            >
          </div>-->
          <div class="effect-lists">
            <material-select :type="1" @selected="handleSelectedImg">
              <template slot="body">
                <a-radio
                  style="padding: 10px 10px 10px 0"
                  :value="customItem.value"
                  :checked="customItem.value === currentSpecialType"
                  >{{ customItem.title }}</a-radio
                >
              </template>
            </material-select>
          </div>
        </div>
        <!-- 啟用特效 -->
        <div class="open-btn">
          <a-checkbox
                  :checked="special_is_open === 1"
                  @change="isOpenEffects"
          >{{ $t("edit.openSpecial") }}
          </a-checkbox
          >
        </div>
        <!--scene-->
        <div
          class="scroll-base"
          v-if="!special_is_global && !isSetshine"
        >
          <div class="item-wrapper">
            <ImageItem
              :itemObj="value"
              v-for="(value, k) in allScenes"
              :key="k"
              :selected="selectedScene"
              @click.native="selectScene(value)"
            ></ImageItem>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import MaterialSelect from "@/components/MaterialSelect";
import ImageItem from "../ImageItem.vue";

export default {
  components: { MaterialSelect, ImageItem },
  data() {
    return {
      // hotspotObj: {},
      // homeShow: true,
      // sceneShow: false,
      // isAddNew: true,
      // showAddPannel: false,
      // editTarget: null,
      // currHotId: "",
      // currentTypeItem: {},

      step1: true,
      step2: false,
      step3: false,
      special_is_global: 1,
      special_is_open: 1,
      specialEffects: [
        {
          value: "rain",
          title: this.$t("edit.lightRain"),
          // icon: require("../../assets/img/Light_Rain.png"),
        }, //小雨
        {
          value: "midrain",
          title: this.$t("edit.midRain"),
          // icon: require("../../assets/img/Moderate_Rain.png"),
        }, //中雨
        {
          value: "heavyrain",
          title: this.$t("edit.heavyRain"),
          // icon: require("../../assets/img/Heavy_Rain.png"),
        }, //大雨
        {
          value: "defaultsnow",
          title: this.$t("edit.lightSnow"),
          // icon: require("../../assets/img/Light_Snow.png"),
        }, //小雪
        {
          value: "snowballs",
          title: this.$t("edit.midSnow"),
          // icon: require("../../assets/img/Moderate_Snow.png"),
        }, //中雪
        {
          value: "snowflakes",
          title: this.$t("edit.heavySnow"),
          // icon: require("../../assets/img/Heavy_Snow.png"),
        }, //大雪
        {
          value: "goldenstars",
          title: this.$t("edit.stars"),
          // icon: require("../../assets/img/Stars.png"),
        }, //下金星
        {
          value: "hearts",
          title: this.$t("edit.hearts"),
          // icon: require("../../assets/img/Hearts.png"),
        }, //下愛心
        {
          value: "money",
          title: this.$t("edit.redEnvelope"),
          // icon: require("../../assets/img/Red_Envelope.png"),
        }, //下紅包
        {
          value: "sunLight",
          title: this.$t("edit.sunLight"),
          // icon: require("../../assets/img/sunlight.png"),
        }, //太陽光
       /* {
          value: "custom",
          title: this.$t("edit.customEffect"),
          // icon: require("../../assets/img/sunlight.png"),
        },*/ //太陽光
      ],
      customItem: {
        value: "custom",
        title: this.$t("edit.customEffect"),
        // icon: require("../../assets/img/sunlight.png"),
      },
      currentSpecialType: "",
      currentEffects: {
        custom_img: "",
        is_display: 1,
        is_global: 1,
        special_type: "",
        ath: 0,
        atv: 0,
      },
      customUrl: "",
      selectedScene: [],
      isSetshine: false,
    };
  },
  watch: {
    currentScenesId() {
      this.handleInitListData();
    },
    'currentEffects.special_type': {
      handler: function (newVal, oldVal) {
        this.isSetshine = newVal === 'sunLight';
      }
    }
  },
  created() {
    this.handleInitListData();
  },
  mounted() {
    this.$bus.$on("updateSunEffectSettingFunc", (data) => {
      if (
        data.ath != this.currentEffects.ath ||
        data.atv != this.currentEffects.atv
      ) {
        this.currentEffects.ath = data.ath;
        this.currentEffects.atv = data.atv;
      }
    });
  },
  computed: {
    ...mapGetters(["vrbase", "currentScenesId"]),
    allScenes() {
      return this.vrbase.scenes;
    },
  },
  methods: {
    onChange(e) {
      this.currentEffects.is_global = this.special_is_global = e.target.value;
      console.log("==2=", this.currentEffects.is_global);
    },
    onSpecialChange(value) {
      console.log("radio checked====", value);
      this.currentEffects.special_type = this.currentSpecialType = value;
      this.currentEffects.custom_img = "";
      this.customUrl = "";
      this.updateKrpano();
    },
    handleSelectedImg(value) {
      this.customUrl = value.url;
      this.currentEffects.special_type = this.currentSpecialType = "custom";
      this.currentEffects.custom_img = this.customUrl;
      //update krpano
      this.updateKrpano();
    },
    updateKrpano(init = false) {
      if (this.currentEffects.special_type === "") return;
      if (this.currentEffects.special_type === "sunLight") {
        if(init){
          addSunsetEffect({ath: this.currentEffects.ath,atv: this.currentEffects.atv})
        }else{
          const vh = getSceneViewAt();
          addSunsetEffect({ ath: vh.hlookat, atv: vh.vlookat });
          this.currentEffects.ath = vh.hlookat
          this.currentEffects.atv = vh.vlookat
        }
      } else {
        addsetSpecialEffects(
          this.currentEffects.special_type,
          this.currentEffects.custom_img
        );
      }
    },

    // 這裡過濾掉scene類型的數據
    handleInitListData() {
      console.log(
        "this.vrbase.special_effects.is_global=",
        this.vrbase.special_effects
      );
      if (
        this.vrbase &&
        this.vrbase.special_effects &&
        this.vrbase.special_effects.is_global == 0
      ) {
        this.special_is_global = 0;
      } else {
        this.special_is_global = 1;
      }

      /*if (this.special_is_global && this.vrbase.special_effects) {
        const serveData = JSON.parse(
          JSON.stringify(this.vrbase.special_effects)
        );
        this.currentEffects = { ...this.currentEffects, ...serveData };
      } else {
        const serveData = JSON.parse(
          JSON.stringify(
            this.vrbase.scenes[this.currentScenesId].special_effects
          )
        );
        this.currentEffects = { ...this.currentEffects, ...serveData };
      }*/
      if(
              this.vrbase &&
              this.vrbase.scenes[this.currentScenesId].special_effects &&
              Object.keys(this.vrbase.scenes[this.currentScenesId].special_effects).length
      ){
        const serveData = JSON.parse(
                JSON.stringify(
                        this.vrbase.scenes[this.currentScenesId].special_effects
                )
        );
        this.currentEffects = {...this.currentEffects, ...serveData};
      }else{
        if(this.special_is_global && this.vrbase.special_effects){
          const serveData = JSON.parse(
                  JSON.stringify(this.vrbase.special_effects)
          );
          this.currentEffects = {...this.currentEffects, ...serveData};
        }
      }
      this.customUrl = this.currentEffects.custom_img;
      this.currentSpecialType = this.currentEffects.special_type;
      this.special_is_open = this.currentEffects.is_display;
      this.updateKrpano(true);
    },

    selectScene(item) {
      const sceneId = item.scene_id;
      if (this.selectedScene.includes(item)) {
        var index = this.selectedScene.indexOf(item);
        if (index > -1) {
          this.selectedScene.splice(index, 1);
        }
      } else {
        this.selectedScene.push(item);
      }
    },

    onClickFinish() {
      const vrbase = this.vrbase;
      const setData = JSON.parse(
            JSON.stringify(this.currentEffects)
          );
      if(this.currentEffects.special_type === 'sunLight') {
        vrbase.scenes[this.currentScenesId].special_effects = setData;
      } else {
        if (this.special_is_global === 1) {
          console.log("1");
          vrbase.special_effects = setData;
          for (let key in vrbase.scenes) {
            vrbase.scenes[key].special_effects = setData;
          }
        } else {
          console.log("0");
          vrbase.special_effects.is_global = 0;
          for (let key in vrbase.scenes) {
            const scene = vrbase.scenes[key];
            if (this.selectedScene.includes(scene)) {
              scene.special_effects = setData;
            }
          }
        }
      }
      this.$store.dispatch("setVRBase", vrbase);
      this.$store.dispatch("saveVRBase",{ vrbase, showLoading: true,})
    },
    //啟用特效
    isOpenEffects(e) {
      this.currentEffects.is_display = e.target.checked ? 1 : 0;
      this.special_is_open = this.currentEffects.is_display;
      if (this.currentEffects.is_display) {
        //打開特效
        this.currentEffects.special_type = this.currentSpecialType = "defaultsnow";
        this.currentEffects.custom_img = "";
        this.customUrl = "";
        this.updateKrpano();
      } else {
        //關閉特效
        this.currentEffects.special_type = this.currentSpecialType = "";
        this.currentEffects.custom_img = "";
        this.customUrl = "";
        removeSpecialEffects();
      }
    },
  },
};
</script>

<style lang="less" scoped>
  /deep/ .ant-radio-wrapper {
  color: #ffffff ;
}

/deep/ .ant-radio-checked .ant-radio-inner{
  border-color: #015c61;
}
/deep/ .ant-radio-inner::after{
  background-color: #015c61;
}
  /deep/.ant-radio-wrapper:hover .ant-radio, /deep/.ant-radio:hover .ant-radio-inner, /deep/.ant-radio-input:focus + .ant-radio-inner{
    border-color: #015c61;
  }

.select-type {
  padding: 3px 0 10px 0;
  width: 100%;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.select-effects {
  border-top: 1px solid rgba(255,255,255,.04);
}
.effect-lists {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  align-items: center;
  width: 100%;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  border-top: 1px solid rgba(255,255,255,.04);
  &:first-child{
    border-top: 0;
  }
  &:last-child{
    border-bottom: 0;
  }
  /*box-shadow: 0 1px 1px 0 rgba(255, 255, 255, 0.05);*/
}
  .scroll-base{
    padding: 10px;
    background-color: rgba(0,0,0,.08);
    border-radius: 5px;
  }

  .open-btn{
    border-top: 1px solid rgba(0,0,0,.1);
    position: relative;
    padding: 10px 0;
    &::before{
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 1px;
      background-color: rgba(255,255,255,.05);
    }
    /deep/ .ant-checkbox-wrapper{
      color: #ffffff;
    }
    /deep/ .ant-checkbox-checked .ant-checkbox-inner{
      background-color: #015c61;
      border-color: #015c61;
    }
    /deep/.ant-checkbox-wrapper:hover .ant-checkbox-inner, /deep/.ant-checkbox:hover .ant-checkbox-inner, /deep/.ant-checkbox-input:focus + .ant-checkbox-inner{
      border-color: #015c61;
    }
    /deep/ .ant-checkbox-checked::after{
      border-color: #015c61;
    }
  }
</style>
